import React, { useState } from "react";

import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Box,
  Button,
  Menu,
  MenuItem,
  Tooltip,
  Container,
  Typography
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import { Link, useNavigate } from "react-router-dom";

import SideMenu from "./SideMenu";

const Header = ({
  user,
  getTotalItems,
  onLogout
}) => {

  const [anchorEl, setAnchorEl] =
    useState(null);

  const [drawerOpen, setDrawerOpen] =
    useState(false);

  const navigate = useNavigate();

  const handleMenuOpen = (e) =>
    setAnchorEl(e.currentTarget);

  const handleMenuClose = () =>
    setAnchorEl(null);

  const handleNavigate = (path) => {

    navigate(path);

    setDrawerOpen(false);

    window.scrollTo(0, 0);
  };

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          zIndex: 1500,

          background:
            "rgba(255,248,242,0.78)",

          backdropFilter: "blur(18px)",

          WebkitBackdropFilter:
            "blur(18px)",

          borderBottom:
            "1px solid rgba(139,0,0,0.08)",

          boxShadow:
            "0 8px 30px rgba(0,0,0,0.04)"
        }}
      >
        <Container maxWidth="xl">

          <Toolbar
            disableGutters
            sx={{
              minHeight: {
                xs: 72,
                md: 82
              },

              justifyContent:
                "space-between"
            }}
          >

            {/* LEFT */}
            <Box
              display="flex"
              alignItems="center"
              gap={2}
            >

              <IconButton
                onClick={() =>
                  setDrawerOpen(
                    (prev) => !prev
                  )
                }
                sx={{
                  color: "#5c0000",

                  bgcolor:
                    "rgba(255,255,255,0.08)",

                  "&:hover": {
                    bgcolor:
                      "rgba(255,255,255,0.14)"
                  }
                }}
              >
                <MenuIcon />
              </IconButton>

              {/* LOGO */}
              <Link
                to="/"
                style={{
                  textDecoration: "none"
                }}
              >
                <Box
                  component="img"
                  src="https://res.cloudinary.com/dshd6sbca/image/upload/v1779016235/ChatGPT_Image_May_17_2026_04_36_43_PM_huj76e.png"
                  alt="SwadVeda"
                  sx={{
                    height: {
                      xs: 44,
                      md: 58
                    },

                    width: "auto",

                    objectFit: "contain",

                    display: "block"
                  }}
                />
              </Link>

            </Box>

            {/* CENTER NAV */}
            <Box
              sx={{
                display: {
                  xs: "none",
                  md: "flex"
                },

                alignItems: "center",

                gap: 1
              }}
            >

              {[
                {
                  label: "Home",
                  path: "/"
                },

                {
                  label: "Shop",
                  path: "/shop"
                },

                {
                  label: "About",
                  path: "/about"
                },

                {
                  label: "Contact",
                  path: "/contact"
                }

              ].map((item) => (

                <Button
                  key={item.label}
                  onClick={() =>
                    handleNavigate(
                      item.path
                    )
                  }
                  sx={{
                    color: "#5c0000",

                    textTransform:
                      "none",

                    fontWeight: 600,

                    fontSize: 15,

                    px: 2,

                    borderRadius: "12px",

                    "&:hover": {
                      background:
                        "rgba(139,0,0,0.08)"
                    }
                  }}
                >
                  {item.label}
                </Button>

              ))}

            </Box>

            {/* RIGHT */}
            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
            >

              {/* CART */}
              {user && (
                <Link to="/cart">

                  <IconButton
                    sx={{
                      color: "#5c0000",

                      bgcolor:
                        "rgba(255,255,255,0.08)",

                      "&:hover": {
                        bgcolor:
                          "rgba(255,255,255,0.14)"
                      }
                    }}
                  >

                    <Badge
                      badgeContent={getTotalItems()}
                      color="warning"
                    >
                      <ShoppingCartIcon />
                    </Badge>

                  </IconButton>

                </Link>
              )}

              {/* USER */}
              {user ? (
                <>

                  <Button
                    onClick={
                      handleMenuOpen
                    }
                    sx={{
                      color: "#5c0000",

                      textTransform:
                        "none",

                      fontWeight: 700,

                      borderRadius:
                        "999px",

                      px: 2,

                      py: 1,

                      background:
                        "rgba(255,255,255,0.08)",

                      "&:hover": {
                        background:
                          "rgba(255,255,255,0.14)"
                      }
                    }}
                  >
                    👋 {user.firstName}
                  </Button>

                  {/* PROFILE DROPDOWN */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={
                      handleMenuClose
                    }

                    disableScrollLock

                    anchorOrigin={{
                      vertical:
                        "bottom",

                      horizontal:
                        "right"
                    }}

                    transformOrigin={{
                      vertical: "top",

                      horizontal:
                        "right"
                    }}

                    PaperProps={{
                      elevation: 0,

                      sx: {
                        mt: 1,

                        minWidth: 230,

                        width: 230,

                        borderRadius:
                          "20px",

                        overflow:
                          "hidden",

                        backdropFilter:
                          "blur(18px)",

                        WebkitBackdropFilter:
                          "blur(18px)",

                        background:
                          "rgba(255,255,255,0.96)",

                        border:
                          "1px solid rgba(139,0,0,0.08)",

                        boxShadow:
                          "0 16px 40px rgba(0,0,0,0.12)",

                        p: 1
                      }
                    }}
                  >

                    {/* USER CARD */}
                    <Box
                      sx={{
                        px: 2,

                        py: 1.6,

                        borderRadius:
                          "16px",

                        mb: 1.2,

                        background:
                          "linear-gradient(135deg,#5c0000,#8B0000)",

                        color: "#fff"
                      }}
                    >

                      <Typography
                        sx={{
                          fontWeight: 700,

                          fontSize: "1rem",

                          lineHeight: 1.2
                        }}
                      >
                        {user?.firstName}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "0.78rem",

                          opacity: 0.82,

                          mt: 0.5,

                          wordBreak:
                            "break-word"
                        }}
                      >
                        {user?.email}
                      </Typography>

                    </Box>

                    {/* PROFILE */}
                    <MenuItem
                      onClick={() => {
                        navigate(
                          "/profile"
                        );

                        handleMenuClose();
                      }}
                      sx={{
                        borderRadius:
                          "12px",

                        py: 1.1,

                        px: 1.5,

                        mb: 0.3,

                        fontWeight: 600,

                        fontSize:
                          "0.95rem",

                        transition:
                          "all 0.2s ease",

                        "&:hover": {
                          background:
                            "rgba(139,0,0,0.08)",

                          transform:
                            "translateX(3px)"
                        }
                      }}
                    >
                      👤 Profile
                    </MenuItem>

                    {/* ORDERS */}
                    <MenuItem
                      onClick={() => {
                        navigate(
                          "/my-orders"
                        );

                        handleMenuClose();
                      }}
                      sx={{
                        borderRadius:
                          "12px",

                        py: 1.1,

                        px: 1.5,

                        mb: 0.3,

                        fontWeight: 600,

                        fontSize:
                          "0.95rem",

                        transition:
                          "all 0.2s ease",

                        "&:hover": {
                          background:
                            "rgba(139,0,0,0.08)",

                          transform:
                            "translateX(3px)"
                        }
                      }}
                    >
                      📦 My Orders
                    </MenuItem>

                    {/* ADMIN */}
                    {user?.role ===
                      "admin" && (
                      <MenuItem
                        onClick={() => {
                          navigate(
                            "/admin/orders"
                          );

                          handleMenuClose();
                        }}
                        sx={{
                          borderRadius:
                            "12px",

                          py: 1.1,

                          px: 1.5,

                          mb: 0.3,

                          fontWeight: 600,

                          fontSize:
                            "0.95rem",

                          transition:
                            "all 0.2s ease",

                          "&:hover": {
                            background:
                              "rgba(139,0,0,0.08)",

                            transform:
                              "translateX(3px)"
                          }
                        }}
                      >
                        📋 Manage Orders
                      </MenuItem>
                    )}

                    {user?.role ===
                      "admin" && (
                      <MenuItem
                        onClick={() => {
                          navigate(
                            "/admin/products"
                          );

                          handleMenuClose();
                        }}
                        sx={{
                          borderRadius:
                            "12px",

                          py: 1.1,

                          px: 1.5,

                          mb: 0.3,

                          fontWeight: 600,

                          fontSize:
                            "0.95rem",

                          transition:
                            "all 0.2s ease",

                          "&:hover": {
                            background:
                              "rgba(139,0,0,0.08)",

                            transform:
                              "translateX(3px)"
                          }
                        }}
                      >
                        ⚙️ Manage Products
                      </MenuItem>
                    )}

                    {/* LOGOUT */}
                    <Box
                      sx={{
                        mt: 1,

                        pt: 1,

                        borderTop:
                          "1px solid rgba(0,0,0,0.06)"
                      }}
                    >

                      <MenuItem
                        onClick={() => {

                          handleMenuClose();

                          onLogout();
                        }}
                        sx={{
                          borderRadius:
                            "12px",

                          py: 1.1,

                          px: 1.5,

                          color:
                            "#b00020",

                          fontWeight: 700,

                          transition:
                            "all 0.2s ease",

                          "&:hover": {
                            background:
                              "rgba(176,0,32,0.08)",

                            transform:
                              "translateX(3px)"
                          }
                        }}
                      >
                        🚪 Logout
                      </MenuItem>

                    </Box>

                  </Menu>

                </>
              ) : (

                <Tooltip title="Sign In">

                  <IconButton
                    sx={{
                      color: "#5c0000",

                      bgcolor:
                        "rgba(255,255,255,0.08)",

                      "&:hover": {
                        bgcolor:
                          "rgba(255,255,255,0.14)"
                      }
                    }}
                    onClick={() =>
                      navigate(
                        "/login"
                      )
                    }
                  >
                    <AccountCircleIcon />
                  </IconButton>

                </Tooltip>
              )}

            </Box>

          </Toolbar>
        </Container>
      </AppBar>

      {/* SIDE MENU */}
      <SideMenu
        open={drawerOpen}
        toggleDrawer={() =>
          setDrawerOpen(false)
        }
        navigate={navigate}
        user={user}
        onLogout={onLogout}
      />
    </>
  );
};

export default Header;